import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { ExToolbar, ExTable } from './components'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionListTransaction, actionFinishTransaction, actionRejectTransaction, actionEditOrderTransaction } from '../../store/actions/transactionSgh'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      width: '100%'
    }
  },
  content: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      overflowX: 'auto'
    }
  }
}))

const TransactionListSGH = ({
  transaction, 
  finishTransaction,
  rejectTransaction,
  editOrderTransaction,
  dispatchListTransaction,
  dispatchFinishTransaction,
  dispatchRejectTransaction,
  dispatchEditOrderTransaction
}) => {
  var delay = null
  const classes = useStyles()
  const [onState, setOnState] = useState(true)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [status, setStatus] = useState('')
  const [code, setCode] = useState('')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [transactions, setTransactions] = useState([])

  useEffect(() => {
    if(onState) {
      dispatchListTransaction(page, limit, code, startDate, endDate, status)
    }
  }, [dispatchListTransaction, onState, page, limit, code, startDate, endDate, status])

  useEffect(() => {
    if(transaction.payload) {
      setTransactions(transaction.payload)
      setPage(transaction.page)
      setPages(transaction.pages)
      setOnState(false)
    }
  }, [transaction.payload, transaction.page, transaction.pages])

  const handlePageChange = (event, page) => {
    setPage(page+1)
    setOnState(true)
  }

  const handleRowsPerPageChange = event => {
    setPage(1)
    setLimit(event.target.value)
    setOnState(true)
  }

  const handleSearch = (event) => {
    const terms = event.target.value
    if(delay) clearTimeout(delay)

    if(!transaction.loading) {
      delay = setTimeout(() => {
        setCode(terms)
        setPage(1)
        setOnState(true)
      }, 600)
    }
  }

  const handleChangeStatus = (event) => {
    setStatus(event.target.value)
    setPage(1)
    setOnState(true)
  }

  useEffect(() => {
    if(finishTransaction.success) {
      setOnState(true)
    }
  }, [finishTransaction.success])

  useEffect(() => {
    if(rejectTransaction && rejectTransaction.success) {
      setOnState(true)
    }
  }, [rejectTransaction && rejectTransaction.success])

  useEffect(() => {
    if(editOrderTransaction && editOrderTransaction.success) {
      setOnState(true)
    }
  }, [editOrderTransaction && editOrderTransaction.success])

  const hanndleFinishData = (id) => {
    dispatchFinishTransaction(id)
  }

  const handleRejectData = (id) => {
    dispatchRejectTransaction(id)
  }

  const handleEditOrderData = (id, data) => {
    dispatchEditOrderTransaction(id, data)
  }

  const handleChangeStartDate = (value) => {
    if(endDate && endDate < value) {
      setEndDate(value)
      setStartDate(value)
      setOnState(true)
      return
    }

    setStartDate(value)
    setOnState(true)
  }

  const handleChangeEndDate = (value) => {
    if(startDate && startDate > value) {
      setStartDate(value)
      setEndDate(value)
      setOnState(true)
      return
    }

    setEndDate(value)
    setOnState(true)
  }

  const handleClearDate = () => {
    setStartDate(null)
    setEndDate(null)
    setStatus('')
    setOnState(true)
  }

  return (
    <div className={classes.root}>
      <ExToolbar 
        onSearch={handleSearch} 
        startDate={startDate}
        endDate={endDate}
        status={status}
        onChangeStatus={handleChangeStatus}
        onChangeStartDate={handleChangeStartDate}
        onChangeEndDate={handleChangeEndDate}
        onClearDate={handleClearDate}
        sum={transaction.sum}
      />

      <div className={classes.content}>
        <ExTable 
          transactions={transactions}
          page={page} 
          pages={pages} 
          limit={limit}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          onFinishData={hanndleFinishData}
          onRejectData={handleRejectData}
          onEditOrderData={handleEditOrderData}
        />
      </div>
    </div>
  )
}

TransactionListSGH.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    transaction: {
      loading: state.transactionSgh.listTransaction.loading,
      page: state.transactionSgh.listTransaction.page,
      pages: state.transactionSgh.listTransaction.pages,
      sum: state.transactionSgh.listTransaction.sum,
      payload: state.transactionSgh.listTransaction.payload
    },
    finishTransaction: {
      success: state.transactionSgh.finishTransaction ? state.transactionSgh.finishTransaction.success : null
    },
    rejectTransaction: {
      success: state.transactionSgh.rejectTransaction ? state.transactionSgh.rejectTransaction.success : null
    },
    editOrderTransaction: {
      success: state.transactionSgh.editOrderTransaction ? state.transactionSgh.editOrderTransaction.success : null
    }
  }
}

const mapDispatchToProps = (dispatch) => { 
  return {
    dispatchListTransaction: (page, limit, code, startDate, endDate, status) => dispatch(actionListTransaction(page, limit, code, startDate, endDate, status)),
    dispatchFinishTransaction: (transactionId) => dispatch(actionFinishTransaction(transactionId)),
    dispatchRejectTransaction: (transactionId) => dispatch(actionRejectTransaction(transactionId)),
    dispatchEditOrderTransaction: (transactionId, data) => dispatch(actionEditOrderTransaction(transactionId, data))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TransactionListSGH)
